import React, { Component } from "react";
import {
  loading,
  NavbarCustomer,
  t
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ

export default class ServiceSummaryReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_date_range: "Last 30 Days",
      filter_status: "All Status",
      filter_category: "All Categories",

      // -----------------------------------
      // Mock Data: Summary Stats
      // -----------------------------------
      summary: {
        total: 48,
        total_change: "+8% vs previous",
        completed: 42,
        completed_rate: "87.5% completion",
        in_progress: 4,
        in_progress_rate: "8.3% of total",
        pending: 2,
        pending_rate: "4.2% of total"
      },

      // -----------------------------------
      // Mock Data: Report Table List (อิงตามรูป image_164fb9.png)
      // -----------------------------------
      data: [
        { id: "SR-2025-048", date: "Feb 15, 2025", category: "HVAC", desc: "Chiller maintenance", priority: "High", priorityColor: "danger", status: "Completed", statusColor: "success", resolution: "4 hours" },
        { id: "SR-2025-047", date: "Feb 14, 2025", category: "Electrical", desc: "Panel inspection", priority: "Medium", priorityColor: "warning", status: "In Progress", statusColor: "primary", resolution: "-" },
        { id: "SR-2025-046", date: "Feb 12, 2025", category: "Plumbing", desc: "Pipe repair", priority: "Low", priorityColor: "primary", status: "Completed", statusColor: "success", resolution: "2 hours" },
        { id: "SR-2025-045", date: "Feb 10, 2025", category: "Mechanical", desc: "Conveyor belt adjustment", priority: "High", priorityColor: "danger", status: "Completed", statusColor: "success", resolution: "6 hours" },
        { id: "SR-2025-044", date: "Feb 8, 2025", category: "HVAC", desc: "AHU filter replacement", priority: "Medium", priorityColor: "warning", status: "Completed", statusColor: "success", resolution: "3 hours" }
      ]
    };
  }

  async componentDidMount() {
    loading(false);
  }

  render() {
    const { summary, data, filter_date_range, filter_status, filter_category } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark">{t("service_summary_report")}</h3>
            <div className="text-secondary text-14">{t("overview_desc")}</div>
          </div>

          {/* Filter Bar */}
          <div className="bg-white rounded-4 shadow-sm p-3 mb-4 d-flex flex-wrap align-items-end gap-3 border border-light">
            <div className="flex-grow-1" style={{ minWidth: '200px' }}>
              <label className="form-label text-secondary text-12 fw-bold mb-2">{t("date_range")}</label>
              <select className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none">
                <option>{t("last_30_days")}</option>
              </select>
            </div>
            <div className="flex-grow-1" style={{ minWidth: '200px' }}>
              <label className="form-label text-secondary text-12 fw-bold mb-2">{t("status")}</label>
              <select className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none">
                <option>{t("all_status")}</option>
              </select>
            </div>
            <div className="flex-grow-1" style={{ minWidth: '200px' }}>
              <label className="form-label text-secondary text-12 fw-bold mb-2">{t("category")}</label>
              <select className="form-select rounded-3 border-light bg-light text-dark fw-bold text-13 shadow-none">
                <option>{t("all_categories")}</option>
              </select>
            </div>
            <button className="btn btn-primary px-4 fw-bold rounded-3 shadow-sm border-0 d-flex align-items-center" style={{ height: '42px' }}>
              <span className="icon me-2">{"\uf0b0"}</span> {t("apply_filters")}
            </button>
          </div>

          {/* KPI Summary Cards */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-primary rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-primary text-12 fw-bold mb-1">{t("total_requests")}</div>
                <h2 className="fw-bold text-dark mb-1">{summary.total}</h2>
                <div className="text-primary text-10 fw-bold">{summary.total_change}</div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-success rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-success text-12 fw-bold mb-1">{t("completed")}</div>
                <h2 className="fw-bold text-dark mb-1">{summary.completed}</h2>
                <div className="text-success text-10 fw-bold">{summary.completed_rate}</div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-warning rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-warning text-12 fw-bold mb-1">{t("in_progress")}</div>
                <h2 className="fw-bold text-dark mb-1">{summary.in_progress}</h2>
                <div className="text-warning text-10 fw-bold">{summary.in_progress_rate}</div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 border-start border-5 border-danger rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-danger text-12 fw-bold mb-1">{t("pending")}</div>
                <h2 className="fw-bold text-dark mb-1">{summary.pending}</h2>
                <div className="text-danger text-10 fw-bold">{summary.pending_rate}</div>
              </div>
            </div>
          </div>

          {/* Graphs Area */}
          <div className="row g-4 mb-4">
            <div className="col-lg-8">
              <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                <h6 className="fw-bold text-dark mb-4">{t("request_trend")}</h6>
                <div className="d-flex align-items-center justify-content-center bg-light rounded-3" style={{ height: '250px' }}>
                  <span className="text-secondary opacity-50">[ Area Chart Placeholder ]</span>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="card border-0 rounded-4 shadow-sm p-4 bg-white h-100">
                <h6 className="fw-bold text-dark mb-4">{t("status_breakdown")}</h6>
                <div className="d-flex align-items-center justify-content-center" style={{ height: '250px' }}>
                   <div className="position-relative d-flex align-items-center justify-content-center">
                      <div className="rounded-circle border border-5 border-success" style={{ width: '150px', height: '150px' }}></div>
                      <div className="position-absolute icon text-success text-24">{"\uf200"}</div>
                   </div>
                </div>
              </div>
            </div>
          </div>

          {/* Details Table */}
          <div className="card border-0 rounded-4 shadow-sm pb-2 overflow-hidden bg-white">
            <div className="p-4 border-bottom border-light">
              <h6 className="fw-bold text-dark mb-0">{t("service_request_details")}</h6>
            </div>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0">
                <thead>
                  <tr className="text-secondary fw-bold text-12 border-bottom border-light bg-light bg-opacity-50">
                    <th className="py-3 px-4 border-0">{t("request_id")}</th>
                    <th className="py-3 border-0">{t("date")}</th>
                    <th className="py-3 border-0">{t("category")}</th>
                    <th className="py-3 border-0">{t("description")}</th>
                    <th className="py-3 border-0 text-center">{t("priority")}</th>
                    <th className="py-3 border-0 text-center">{t("status")}</th>
                    <th className="py-3 border-0 text-center">{t("resolution_time")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => (
                    <tr key={idx} className="border-bottom border-light">
                      <td className="py-4 px-4 fw-bold text-primary font-monospace">{item.id}</td>
                      <td className="text-secondary text-13">{item.date}</td>
                      <td className="text-secondary text-13">{item.category}</td>
                      <td className="text-dark text-13 fw-medium">{item.desc}</td>
                      <td className="text-center">
                        <span className={`badge bg-${item.priorityColor}-light text-${item.priorityColor} rounded-pill px-3 py-1 fw-bold text-10`}>
                          {item.priority}
                        </span>
                      </td>
                      <td className="text-center">
                        <span className={`badge bg-${item.statusColor}-light text-${item.statusColor} rounded-pill px-3 py-1 fw-bold text-10`}>
                          {item.status}
                        </span>
                      </td>
                      <td className="text-center text-secondary text-13 fw-bold">{item.resolution}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Actions */}
          <div className="d-flex justify-content-between align-items-center mt-4 bg-white p-3 rounded-4 shadow-sm border border-light">
            <div className="text-secondary text-12">
              {t("report_generated")}: Feb 19, 2026 at 10:30 AM
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-white border px-3 py-2 text-danger fw-bold rounded-3 d-flex align-items-center shadow-none">
                <span className="icon me-2">{"\uf1c1"}</span> {t("export_pdf")}
              </button>
              <button className="btn btn-white border px-3 py-2 text-success fw-bold rounded-3 d-flex align-items-center shadow-none">
                <span className="icon me-2">{"\uf1c3"}</span> {t("export_excel")}
              </button>
              <button className="btn btn-primary px-4 py-2 fw-bold rounded-3 shadow-sm border-0 d-flex align-items-center">
                <span className="icon me-2">{"\uf02f"}</span> {t("print_report")}
              </button>
            </div>
          </div>

        </div>
      </div>
    );
  }
}